import { Box, Divider } from '@mui/material';

import { Card, CardContent } from '@occc/ui-design-system';
import { StoredValueGuard, StoredValueBalance } from '@occc/feat-stored-value';
import { MembershipFragment, Membership_State } from '@occc/graphql';

import PointDetails from './PointDetails';
import { StatisticsItem } from './StatisticsItem';

const sectionSx = {
  flex: { xs: 'none', md: '1 1 0' },
  minWidth: { md: 0 },
  width: { xs: '100%', md: 'auto' },
} as const;

const rowDividerSx = {
  display: { xs: 'none', md: 'flex' },
  flex: '0 0 auto',
  alignItems: 'stretch',
  alignSelf: 'stretch',
} as const;

type StatisticsProps = {
  member: MembershipFragment;
  isPointsAdjustmentEnabled: boolean;
  isUserPermittedToEditMemberPoints: boolean;
  toggleUpdatePointsModal: () => void;
};

export const Statistics = (props: StatisticsProps) => {
  const {
    member,
    toggleUpdatePointsModal,
    isPointsAdjustmentEnabled,
    isUserPermittedToEditMemberPoints,
  } = props;

  return (
    <Card sx={{ mb: 0 }}>
      <CardContent>
        <Box
          display='flex'
          flexDirection={{ xs: 'column', md: 'row' }}
          alignItems='stretch'
          gap={{ xs: 2, md: 0 }}
        >
          <Box sx={sectionSx}>
            <PointDetails
              points={member.points}
              toggleUpdatePointsModal={toggleUpdatePointsModal}
              isPointsAdjustmentEnabled={isPointsAdjustmentEnabled}
              isEditable={
                member.state !== Membership_State.Deleted && isUserPermittedToEditMemberPoints
              }
            />
          </Box>
          <Box sx={rowDividerSx}>
            <Divider orientation='vertical' flexItem />
          </Box>

          <StoredValueGuard fallback={null}>
            <Box sx={sectionSx}>
              <StoredValueBalance balance={member.storedValueBalance ?? 0} />
            </Box>
            <Box sx={rowDividerSx}>
              <Divider orientation='vertical' flexItem />
            </Box>
          </StoredValueGuard>

          <Box sx={sectionSx}>
            <StatisticsItem value={member.offerPurchases.totalCount} label='Total Redemptions' />
          </Box>
          <Box sx={rowDividerSx}>
            <Divider orientation='vertical' flexItem />
          </Box>

          <Box sx={sectionSx}>
            <StatisticsItem value={member.transactions.totalCount} label='Total Transactions' />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};
